import { Component, computed, input } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';

@Component({
    selector: 'r1-compass-app-file-preview',
    imports: [MatTableModule],
    template: `
        <div class="preview">
            @if (uploadedFilePreview()) {
                <table mat-table [dataSource]="dataSource()">
                    @for (column of tableHeaders(); track $index) {
                        <ng-container matColumnDef="{{ column }}">
                            <th class="header-cell" mat-header-cell *matHeaderCellDef>{{ column }}</th>
                            <td class="data-cell" mat-cell *matCellDef="let row">{{ row[$index] }}</td>
                        </ng-container>
                    }
                    <tr mat-header-row *matHeaderRowDef="tableHeaders(); sticky: true"></tr>
                    <tr mat-row *matRowDef="let row; columns: tableHeaders()"></tr>
                </table>
            }
        </div>
    `,
    styles: `
        .preview {
            max-height: 250px;
            overflow-y: auto;
        }
    `,
})
export class FilePreviewComponent {
    public readonly uploadedFilePreview = input<Array<string[]> | undefined>([]);

    protected tableHeaders = computed<string[]>(() => this.uploadedFilePreview()?.[0] ?? []);
    protected dataSource = computed<MatTableDataSource<string[], MatPaginator>>(
        () => new MatTableDataSource<string[]>(this.uploadedFilePreview()?.slice(1))
    );
}
